import service from "./service";
export const VERSION = "v1.6.0/" ;  
const authManager = "/auth-manager/"+VERSION;
export const niyama = "/niyama-api/"+VERSION;
export const firebase = "/firebase/"+VERSION;
export const chatBot= "/chat-bot/"+VERSION;
export const billDesk= "/bill-desk/"+VERSION;
export const phi = "/phi/"+VERSION;
export default {
  updateExpiryDate: function (data) {
    let url = `${niyama}edit-coupon/`;
    return service.post(url, data);
  },
  get_coupon_list: function (page,page_size,plan_name,coupon_name) {
    let url = `${niyama}admin-coupon-list/?page=${page}&page_size=${page_size}&plan_name=${plan_name}&coupon_name=${coupon_name}`;
    return service.get(url);
  },
  jwtRefresh: function (data) {
    const authManager = "/auth-manager/"+"v2.0.0/";
    let url = `${authManager}jwt/refresh/`;
    return service.post(url, data);
  },
  register: function (data) {
    let url = `${authManager}sign-up/`;
    return service.post(url, data);
  },
  user_register: function (data) {
    let url = `${authManager}user-register/`;
    return service.post(url, data);
  },
  user_register_through_parent: function (data) {
    let url = `${niyama}profile-create/`;
    return service.post(url, data);
  },
  login: function (data) {
    let url = `${authManager}log-in/`;
    return service.post(url, data);
  },
  login_through_parent: function (data) {
    let url = `${niyama}account-details/`;
    return service.get(url, data);
  },
  submit_misinformation: function (data){
    let url = `${niyama}report-misinformation/`;
    return service.post(url, data);
  },
  profile_update: function (data) {
    let url = `${niyama}profile-update/`;
    return service.post(url, data);
  },
  voice_otp: function (data) {
    let url = `${authManager}get-otp-in-call/`;
    let allData = JSON.parse(localStorage.getItem("persist:root"));
    let loginReducer = JSON.parse(allData.loginReducer);
    let uuid =  localStorage.getItem("setGuestUUID") ? localStorage.getItem("setGuestUUID") : loginReducer?.guest_uuid || "";
    if (data.type != "register" && uuid && data.type != "recover") {
      url = `${authManager}get-otp-in-call/`;
      data = data.type=="b2b" ? {...data} : { ...data, uuid };
    }
    // data={...data,mobile_number: '9940414684'}
    return service.post(url, data);
  },
  send_otp: function (data) {
    let url = `${authManager}send-otp/`;
    return service.post(url, data);
  },
  send_otp_dup: function (data) {
    let url = `${authManager}send-otp/`;
    let allData = JSON.parse(localStorage.getItem("persist:root"));
    let loginReducer = JSON.parse(allData.loginReducer);
    let uuid =  localStorage.getItem("setGuestUUID") ? localStorage.getItem("setGuestUUID") : loginReducer?.guest_uuid || "";
    if (data.type != "register" && uuid && data.type != "recover") {
      url = `${authManager}send-otp/`;
      data = data.type=="b2b" ? {...data} : { ...data, uuid };
    }
    if(data?.onlyType){
      data = {type: data.type} // change password after login only type should be sent 
    }
    return service.post(url, data);
  },
  send_otp_verification: function (data) {
    let url = `${authManager}verify-otp/`;
    let allData = JSON.parse(localStorage.getItem("persist:root"));
    let loginReducer = JSON.parse(allData.loginReducer);
    let uuid =  localStorage.getItem("setGuestUUID") ? localStorage.getItem("setGuestUUID") : loginReducer?.guest_uuid || "";
    if (data.type != "register" && uuid && data.type != "recover") {
      url = `${authManager}verify-otp/`;
      data = { ...data, uuid };
    }
    return service.post(url, data);
  },
  verify_otp_dup: function (data) {
    let url = `${authManager}verify-otp/`;
    return service.post(url, data);
  },
  forgotPassword: function (data) {
    let url = `${authManager}password-reset/`;

    return service.post(url, data);
  },
  setNewPassworddup: function (data) {
    let url = `${authManager}reset-password/`;
    return service.post(url, data);
  },
  setNewPassword: function (data) {
    let url = `${authManager}set-new-password/`;
    return service.post(url, data);
  },
  resendOtp: function (data) {
    let url = `${authManager}resend-otp/`;
    return service.post(url, data);
  },
  resendOtp_dup: function (data) {
    let url = `${authManager}resend-otp/`;
    let allData = JSON.parse(localStorage.getItem("persist:root"));
    let loginReducer = JSON.parse(allData.loginReducer);
    let uuid = localStorage.getItem("setGuestUUID") ? localStorage.getItem("setGuestUUID") : loginReducer?.guest_uuid || "";
    if (data.type != "register" && uuid && data.type != "recover") {
      url = `${authManager}resend-otp/`;
      data = { ...data, uuid };
    }
    return service.post(url, data);
  },
  verifyOtp: function (data) {
    let url = `${authManager}verify-otp/`;
    let allData = JSON.parse(localStorage.getItem("persist:root"));
    let loginReducer = JSON.parse(allData.loginReducer);
    let uuid =  localStorage.getItem("setGuestUUID") ? localStorage.getItem("setGuestUUID") : loginReducer?.guest_uuid || "";
    if (data.type != "register" && uuid && data.type != "recover") {
      if (data.mode == "mobile_number") data.mode = "mobile";
      url = `${authManager}verify-otp/`;
      data = data.type=="b2b" ? {...data} : { ...data, uuid };
    }
    return service.post(url, data);
  },
  verifyEmail: function (data) {
    let url = `${authManager}email-mobile-verify/`;
    return service.post(url, data);
  },
  account_inactivate: function (data) {
    let url = `${authManager}account-inactivate/`;
    return service.post(url);
  },
  submit_forms: function (data) {
    let url = `${niyama}submit-forms/`;
    return service.post(url, data);
  },
  get_profile_list: function () {
    let url = `${niyama}profile-list/`;
    return service.get(url);
  },
  get_check_roles: function () {
    let url = `${niyama}check-role/`;
    return service.get(url);
  },
  get_all_languages: function () {
    let url = `${niyama}get-all-languages/`;
    return service.get(url);
  },
  preferred_language_update: function (data) {
    let url = `${niyama}preferred-language-update/`;
    return service.post(url, data);
  },
  language_update: function (data) {
    let url = `${niyama}update-language/`;
    return service.post(url, data);
  },
  get_patient_status: function () {
    let url = `${niyama}get-patient-status/`;
    return service.get(url);
  },
  get_profile_status: function () {
    let url = `${niyama}profile-status/`;
    return service.get(url);
  },
  get_my_profile: function () {
    let url = `${niyama}my-profile/`;
    return service.get(url);
  },
  assessment_type: function () {
    let url = `${niyama}get-patient-status/`;
    return service.get(url);
  },
  assessment_details: function () {
    let url = `${niyama}assessment-detail/`;
    return service.get(url);
  },
  assessment_eligibility: function (uuid) {
    let url = `${niyama}assessment-eligibility/?uuid=${uuid}`;
    return service.get(url);
  },
  guest_assessment_eligibility: function (uuid) {
    let url = `${niyama}guest-assessment-eligibility/?uuid=${uuid}`;
    return service.get(url);
  },
  assessment_test: function (type, assessment_type,uuid) {
    
      let url = `${niyama}assessment-form/?user_type=${type}&assessment_type=${assessment_type}&uuid=${uuid}`;
      return service.get(url);
    
  },
  get_doctor_profile_pic_list: function(){
    let url = `${niyama}clinician-profile-pictures/`;
    return service.get(url);
  },
  get_care_plan_details: function(){
    let url = `${niyama}care-plan-details/`;
    return service.get(url);
  },
  get_area_of_improvement: function(uuid){
    let url = `${niyama}improvement-areas/?uuid=${uuid}`;
    return service.get(url);
  },
  save_area_improvements: function (data) {
    let url = `${niyama}save-improvement-areas/`;
    return service.post(url, data);
  },
  update_area_improvements: function (data) {
    let url = `${niyama}update-improvement-areas/`;
    return service.post(url, data);
  },
  post_pathway_track: function (data) {
    let url = `${niyama}save-profile-status/`;
    return service.post(url, data);
  },
  post_doctor_detail: function(data){
    let url = `${niyama}clinician-details/`;   
    return service.post(url, data);
  },
  get_eligible_specialities: function(){
    let url = `${niyama}eligible-specialities/`
    return service.get(url);
  },
  save_preferred_lang: function (data) {
    let url = `${niyama}save-langauage-communication/`;
    return service.post(url, data);
  },
  save_pro_pic: function (data) {
    let url = `${niyama}save-profile-picture/`;
    return service.post(url, data);
  },
  learn_about_symptoms: function(type,id){
    let url = `${niyama}assessment-details/?assessment_type=${type}&assessment_id=${id}`;
    return service.get(url)
  },
  learn_about_assessment_report: function(type,id){
    let url = `${niyama}assessment-details/`;
    let data={assessment_type:type,assessment_id:id}
    return service.post(url, data)
  },
  assessment_list: function (
    type,
    page,
    page_size,
    filter,
    patient_id,
    role,
    types
  ) {
    let path = `${niyama}assessment-history/`;
    let url = `${path}?type=all&page=${page}&page_size=${page_size}&filter=${filter}${
      role == "doctor" ? "&patient_id=" + patient_id : ""
    }`;
    return service.get(url);
  },
  get_banner_details: function (type) {
    let url = `${niyama}banner-dashboard/?type=${type}`;
    return service.get(url);
  },
  appointment_token: function (data) {
    let url = `${niyama}appointment-token/`;
    return service.post(url, data);
  },
  // prescription_submit: function (data) {
  //   let url = `${niyama}add-prescription/`;
  //   return service.post(url, { ...data, type: "ayurveda" });
  // },
  casesheet_submit: function (data) {
    let url = `${niyama}add-casenotes/`;
    return service.post(url, data);
  },
  get_doctor_dates: function (data) {
    let url = `${niyama}get-doctor-available-dates/`;
    return service.post(url, data);
  },
  add_doctor_instruction: function (data) {
    let url = `${niyama}doctor-instruction/`;
    return service.post(url, data);
  },
  get_doctor_slots: function (data) {
    let url = `${niyama}get-slots/`;
    return service.post(url, data);
  },
  next_consultation_submit: function (data) {
    let url = `${niyama}next-consultation-create/`;
    return service.post(url, data);
  },
  close_appointment_submit: function (data) {
    let url = `${niyama}close-appointment/`;
    return service.post(url, data);
  },
  patient_no_show: function (data) {
    let url = `${niyama}patient-no-show/`;
    return service.post(url,data);
  },
  loadPrescriptionSet: function (data) {
    let url = `${niyama}prescription-load/`;
    return service.post(url, data);
  },
  loadPreDefPrescribtionApi: function () {
    let url = `${niyama}predefined-prescription-type/`;
    return service.get(url);
  },
  assessment_submit: function (data, type) {
    let url = `${niyama}submit-assessment/`;   
    return service.post(url, data);
  },
  patient_settings_update: function (data) {
    let url = `${niyama}emotion-stress-update/`;
    return service.post(url, data);
  },
  update_whatsapp_settings: function (data) {
    let url = `${niyama}update-whatsapp-settings/`;
    return service.post(url, data);
  },
  retrieve_whatsapp_settings: function () {
    let url = `${niyama}retrieve-whatsapp-settings/`;
    return service.get(url);
  },
  schedule_appointment_available_slots: function (data) {
    let url = `${niyama}available-slots/`;
    return service.post(url, data);
  },
  schedule_appointment_available_doctors: function (data) {
    let url = `${niyama}get-available-doctors/`;
    return service.post(url, data);
  },

  schedule_book_appointment: function (data) {
    let url = `${niyama}book-appointment/`;
    return service.post(url, data);
  },

  reschedule_appointment: function (data) {
    let url = `${niyama}reschedule-appointment/`;
    return service.post(url, data);
  },

  cancel_appointment: function (data) {
    let url = `${niyama}cancel-appointment/`;
    return service.post(url, data);
  },
  confirmed_appointment_detail: function (data) {
    let url = `${niyama}confirmed-appointment-detail/`;
    return service.post(url, data);
  },
  appointment_list: function (role, type, page, page_size, filter, search) {
    let url =
      role == "patient"
        ? `${niyama}my-appointments/?page=${page}&page_size=${page_size}&filter=${filter}&type=${type}&search=${search}`
        : `${niyama}my-appointment/?type=${type}&page=${page}&page_size=${page_size}&filter=${filter}&search=${search}`;
    if (role != "patient" && type == "today") {
      url = `${niyama}my-appointment/?type=${type}&filter=${filter}&search=${search}`;
    }
    return service.get(url);
  },
  schedule_appointment_date_selector: function (data) {
    let url = `${niyama}get-available-slot/`;
    return service.post(url, data);
  },
  schedule_appointment_slot_selection: function (data) {
    let url = `${niyama}get-available-doctors/`;
    return service.post(url, data);
  },
  subscription_payment: function (service_id) {
    // let url = `${niyama}subscription-plan/`;
    let url = `${billDesk}initiate-payment/`;    
    return service.post(url, service_id);
  },
  payment_create: function (data) {
    let url = `${niyama}patient-payment-create/`;
    return service.post(url, data);
  },
  payment_status: function (data) {
    let url = `${billDesk}payment-status/`;
    return service.post(url, data);
  },
  payment_no_payment_create: function (data) {
    let url = `${billDesk}payment-not-required/`;    
    return service.post(url, data);
  },
  get_payment_status: function (data) {
    let url = `${billDesk}payment-status/`;    
    return service.post(url, data);
  },
  terminate_payment: function (data) {
    let url = `${billDesk}terminate-payment/`;
    return service.post(url, data);
  },
  care_ticket_create: function () {
    let url = `${niyama}create-care-team-assignment-ticket/`;
    return service.post(url);
  },
  // subscription list
  subscription_list: function (type) {
    let url = `${niyama}subscription-plan-list/?type=${type}`;
    return service.get(url);
  },
  subscription_care_admin_list: function (data) {
    let url = `${niyama}ca-subscription-plan-list/`;
    return service.get(url);
  },
  subscription_care_admin_activate: function (data) {
    // return new Promise((resolve, reject) => {
    //   setTimeout(() => {
    //     resolve({
    //       data:{
    //         "status": 200,        
    //         "message": "Plan activated successfully",
    //       }
    //       })
    //   }, 3000); // 3 seconds delay
    // });
    let url = `${billDesk}ca-plan-activate/`;
    return service.post(url,data);
  },
  get_instruction_history: function (data) {
    let url = `${niyama}list-instruction/`;
    return service.post(url,data);
  },
  // razor pay key list
  razorpaylist_list: function () {
    let url = `${niyama}get-razorpay-key/?type=test`;
    return service.get(url);
  },

  consultation_history_list: function (
    type,
    page,
    page_size,
    role,
    filter,
    search
  ) {
    let url = `${niyama}list-all-past-appointments/?type=all&page=${page}&page_size=${page_size}&role=${role}&filter=${filter}&search=${search}`;
    return service.get(url);
  },

  // phi_summary: function (patient_id, role) {
  //   let url = `${niyama}phi-summary/${role == "doctor" ? ('?patient_id=' + patient_id) : ""}`;
  //   return service.get(url, patient_id, role);
  // },

  phi_summary: function (patient_id, role, type, gender) {
    let url = `${niyama}ahi-summary/?type=${type}&gender=${
      gender || "female"
    }${role == "doctor" ? "&patient_id=" + patient_id : ""}`;
    return service.get(url);
  },

  shorthand_summary: function (patient_id, role, type, gender) {
    let url = `${niyama}ahi-phi-summary/?type=${type || "adult"}&gender=${
      gender || "female"
    }${role == "doctor" ? "&patient_id=" + patient_id : ""}`;
    return service.get(url);
  },
  get_eval_prescription: function (data) {
    let url = `${niyama}diagnosis-treatment/`;
    return service.post(url, data);
  },
  appointment_search_suggestion: function (role, name, all_patients = false, allPatientsScreen = false) {
    let url = `${niyama}search-suggestion?role=${role}&search=${name}`;
    if(allPatientsScreen)
      url = `${niyama}get-all-patient-name-suggestion?role=${role}&search=${name}&is_superclinician=${all_patients}`;
    return service.get(url, true);
  },
  get_consulted_doctors: function (data) {
    let url = `${niyama}get-consulted-doctors/`;
    return service.post(url, data);
  },
  // Care Admin Apis

  get_my_ticket: function (type) {
    let url = `${niyama}ticket-list/?type=${type}`;
    return service.get(url);
  },
  get_my_ticket_byId: function (data) {
    let url = `${niyama}ticket-list-dup/?ticket_id=${data}`;
    return service.get(url);
  },

  get_pending_ticket: function (data) {
    let url = `${niyama}pending-tickets/`;
    return service.get(url);
  },
  care_admin_reschedule_appointment: function (data) {
    let url = `${niyama}appointment-status/`;
    return service.post(url, data);
  },

  care_admin_doctor_allocation_ticket: function (data) {
    let url = `${niyama}doctor-assignment/`;
    return service.post(url, data);
  },
  care_team_assignment_ticket: function (data) {
    let url = `${niyama}care-team-assignment/`;
    return service.post(url, data);
  },

  care_admin_close_ticket: function (data) {
    let url = `${niyama}close-ticket/`;
    return service.post(url, data);
  },
  care_admin_revert_ticket: function (data) {
    let url = `${niyama}revert-ticket-status/`;
    return service.post(url, data);
  },

  care_admin_get_available_slots: function (data) {
    let url = `${niyama}get-slots/`;
    return service.post(url, data);
  },

  care_admin_get_available_dates: function (data) {
    let url = `${niyama}get-doctor-available-dates/`;
    return service.post(url, data);
  },

  care_admin_patient_records: function (data) {
    let url = `${niyama}patient-records/`;
    return service.post(url, data);
  },

  care_admin_doctor_list: function (data) {
    let url = `${niyama}doctor-list/`;
    return service.post(url, data);
  },
  care_admin_profile_list: function (value) {
    let url = `${niyama}profile-list/`;
    if (value?.email) {
      value.email = value.email.trim();
    }
    return service.post(url, value);
  },

  care_admin_patient_upcoming_appointment: function (data) {
    let url = `${niyama}patient-upcoming-appointment/`;
    return service.post(url, data);
  },

  care_admin_change_appointment: function (data) {
    let url = `${niyama}change-appointment/`;
    return service.post(url, data);
  },

  care_admin_direct_cancel_appointment: function (data) {
    let url = `${niyama}direct-cancel-appointment/`;
    return service.post(url, data);
  },

  care_admin_patient_confirmed: function (data) {
    let url = `${niyama}patient-confirmed/`;
    return service.post(url, data);
  },
  care_admin_patient_details: function (value) {
    let url = `${niyama}ca-patient-detail/`;
    if (value?.email) {
      value.email = value.email.trim();
    }
    return service.post(url, value);
  },

  care_admin_patient_plan : function (uuid){
    let url= `${niyama}patient-plan/?patient_uid=${uuid}`
    return service.get(url);
  },

  care_admin_plan_statistics : function (value){
    let url = `${niyama}plan-statistics/`;
    return service.post(url, value);
  },
  care_admin_name_suggestion:function(name){
    let url = `${niyama}ca-name-suggestion/?search=${name}`;
    return service.get(url, true);
  },
  mapped_patient_name_suggestion:function(name){
    let url = `${niyama}di-name-suggestion/?search=${name}`;
    return service.get(url, true);
  },
  mypatients_list: function (
    type,
    page,
    page_size,
    role,
    filter,
    search,
    missed_prescription = false,
    missed_casesheet = false,
    missed_publish = false,
    missed_evalReport_publish = false,
    patient_uid
  ) {
    let url = `${niyama}consultation-history-list/?type=${type}&page=${page}&page_size=${page_size}&role=${role}&filter=${filter}&search=${search}&missed_prescription=${missed_prescription}&missed_casesheet=${missed_casesheet}&email_publish=${missed_publish}&evaluation_publish=${missed_evalReport_publish}&patient_uid=${patient_uid}`;
    return service.get(url);
  },
  ca_list_all_consultations:function(type,page,page_size,patient_uid){
    let url = `${niyama}ca-list-all-consultations/?type=${type}&page=${page}&page_size=${page_size}&patient_uid=${patient_uid}`;
    return service.get(url);
  },
  table_list: function (searchName, missed_prescription, missed_casesheet) {
    let url = `${niyama}my-patient-history-list/?search=${searchName}&missed_prescription=${missed_prescription}&missed_casesheet=${missed_casesheet}`;
    return service.get(url);
  },
  table_list_dup: function (
    searchName,
    missed_prescription,
    missed_casesheet,
    page,
    page_size
  ) {
    let url = `${niyama}my-patient-history-list-dup/?search=${searchName}&missed_prescription=${missed_prescription}&missed_casesheet=${missed_casesheet}&page=${page}&page_size=${page_size}`;
    return service.get(url);
  },
  all_patients_list: function (
    searchName,
    missed_prescription,
    missed_casesheet,
    page,
    page_size,
    is_superclinician =false
  ) {
    let url = `${niyama}get-all-patient-list/?patient_uid=${searchName}&missed_prescription=${missed_prescription}&missed_casesheet=${missed_casesheet}&page=${page}&page_size=${page_size}&is_superclinician=${is_superclinician}`;
    return service.get(url);
  },
  prescription_list: function (appointment_id) {
    let url = `${niyama}get-prescription-list/`;
    return service.post(url, { appointment_id: appointment_id });
  },

  patient_based_doctors_list: function (data) {
    let url = `${niyama}patient-doctor-list/`;
    return service.post(url,data);
  },
  list_doctors: function () {
    let url = `${niyama}list-doctor/`;
    return service.get(url);
  },
  list_users: function () {
    let url = `${niyama}list-users/?role=corporate`;
    return service.get(url);
  },
  list_users_get_data: function (data) {
    // let url = `${niyama}get-org-details/`;
    let url = `${niyama}get-org-details/`;
    return service.post(url, data);
  },
  list_followup_tickets: function (patien_id,sdate,edate,status,page,size) {
    let url = `${niyama}doctor-instruction-list/?status=${status}&patient_uid=${patien_id}&page=${page?page:1}&page_size=${size?size:5}&start_date=${sdate}&end_date=${edate}`;
    return service.get(url);
  },
  doctor_schedule_list: function (docotorId) {
    let url = `${niyama}list-doctor-schedule/`;
    if (docotorId) {
      return service.post(url, { doctor_id: docotorId });
    }
    return service.post(url);
  },

  myAvailabilty_list: function () {
    let url = `${niyama}list-my-availability/`;
    return service.get(url);
  },
  get_patient_info: function (patient_id) {
    let url = `${niyama}patient-detail/`;
    return service.post(url, patient_id);
  },
  case_summary_report: function (patient_id) {
    let url = `${niyama}get-patient-summary/`;
    return service.post(url, patient_id);
  },
  excel_report_status: function (org_id) {
    let url = `${niyama}check-export-status/`;
    return service.post(url, org_id);
  },
  holidays_list: function (doctorId = null) {
    let url = "";
    if (doctorId) {
      url = `${niyama}list-holiday/?doctor_id=${doctorId}`;
    } else {
      url = `${niyama}list-holiday/`;
    }
    return service.get(url);
  },
  addEdit_myAvailabilty_list: function (data) {
    let url = `${niyama}add-edit-availability/`;
    return service.post(url, data);
  },
  addEdit_holidays_list: function (data) {
    let url = `${niyama}add-edit-holiday/`;
    return service.post(url, data);
  },
  get_myorders_list() {
    let url = `${niyama}payment-list/`;
    return service.get(url);
  },
  get_myorders_tab(type, page, pageSize) {
    let url = `${niyama}order-list/?type=${type}&page=${
      page ? page : "1"
    }&page_size=${pageSize ? pageSize : 10}`;
    return service.get(url);
  },
basic_info: function (user_role) {
  let url = `${niyama}user-info/?role_type=${user_role}`;
  return service.get(url);
},
  remove_profile_image: function () {
    let url = `${niyama}delete-profile-picture/`;
    return service.post(url);
  },
  basic_info_update: function (data) {
    let url = `${niyama}user-info-update/`;
    return service.post(url, data);
  },
  get_patientlist: function (data) {
    let url = `${niyama}list-all-patients/?page=1&page_size=10`;
    return service.get(url);
  },
  get_patientlist_pagination: function ({ pageNo, pageSize }) {
    let url = `${niyama}list-all-patients/?page=${pageNo}&page_size=${pageSize}`;
    return service.get(url);
  },
  get_patientlist_filterbypatient: function ({
    pageNo,
    pageSize,
    patient_name,
  }) {
    let url = `${niyama}list-all-patients/?page=${pageNo}&page_size=${pageSize}&type=patient_name&filter=${patient_name}`;
    return service.get(url);
  },
  get_patientlist_filterurl: function (addurl) {
    let url = `${niyama}list-all-patients/?${addurl}`;
    return service.get(url);
  },

  // PHI  Api
  get_phi_dropdown_values: function () {
    let url = `${niyama}option-detail/`;
    return service.get(url);
  },
  get_upload_types: function () {
    let url = `${niyama}get-file-types/`;
    return service.get(url);
  },
  get_upload_phi_documents: function (page, pageSize,patientID,from) {
    let url = `${niyama}list-medical-documents/?patient_id=${patientID}&page=${page ? page : "1"}&page_size=${pageSize ? pageSize : 20}&type=${from}`;
    return service.get(url);
  },
  get_patient_data: function (data) {
    let url = `${niyama}patient-info/`;
    return service.post(url,data);
  },
  get_uploaded_files: function (data, formType) {
    let url = `${niyama}multiple-files-view/`;
    return service.post(url, { appointment_id: data, type: formType });
  },

  delete_uploaded_doc: function (data) {
    let url = `${niyama}multiple-file-delete/`;
    return service.post(url, data);
  },

  upload_documents(page = "phi", multiple = true, data) {
    let url = `${niyama}upload-files/?type=${page}&multiple=${multiple}`;
    return service.post(url, data);
  },
  upload_phi_documents(formdata, type) {
    let url = `${niyama}upload-files/?type=${type}&multiple=false`;
    return service.post(url, formdata);
  },
  upload_multiple_documents(data, multiple = true) {
    let url = `${niyama}multiple-files-upload/?multiple=${multiple}`;
    return service.post(url, data);
  },

  view_document(data) {
    let url = `${niyama}view-files/`;
    return service.post(url, data);
  },

  delete_document(data) {
    let url = `${niyama}delete-files/`;
    return service.post(url, data);
  },

  // Dashboard Api
  get_dashboard_info: function (type) {
    let url = `${niyama}dashboard/?type=${type}`;
    return service.get(url);
  },

  casesheet_list: function (patient_id) {
    let url = `${niyama}get-casenotes-list/`;
    return service.post(url, { patient_id: patient_id });
  },
  get_corporate_dashboard_info: function () {
    let url = `${niyama}corporate-admin-dashboard/`;
    return service.get(url);
  },
  get_corporate_dashboard: function () {
    let url = `${niyama}dashboard/?type=corporate_admin`;
    return service.get(url);
  },
  get_org_dashboard_stats: function () {
    let url = `/niyama-api/v2.0.0/org-dashboard-stats/`;
    return service.get(url);
  },
  get_registration_overview: function ({ month, year }) {
    let url = `/niyama-api/v2.0.0/registration-overview/?month=${month}&year=${year}`;
    return service.get(url);
  },
  // video consultation
  //corporate table
  get_table_nofilter: function ({org_id= ""}) {
    let params = "&page=1&page_size=20";
    // if(org_id)params="";
    let url = `${niyama}corporate-user-list/?org_id=${org_id}${params}`;
    return service.get(url);
  },
  get_corporate_export_data: function ({org_id= ""}) {
    let url = `${niyama}export-corporate-user-list/?org_id=${org_id}`;
    return service.get(url);
  },
  get_table_filter: function ({ pageNo, pageSize, org_id= "" }) {
    let url = `${niyama}corporate-user-list/?page=${pageNo}&page_size=${pageSize}&org_id=${org_id}`;
    return service.get(url);
  },
  get_table_filterbypatient: function ({ pageNo, pageSize, filter= "", org_id= "",type }) {
    let url = `${niyama}corporate-user-list/?page=${pageNo}&page_size=${pageSize}&type=${type}&filter=${filter.trim()}&org_id=${org_id}`;
    return service.get(url);
  },
  get_table_filterurl: function (addurl) {
    let url = `${niyama}corporate-user-list/?${addurl}`;
    return service.get(url);
  },

  // dsm
  get_predefinded_diagnosis: function (data) {
    let url = `${niyama}retrive-for-prescription/`;
    return service.post(url, data);
  },
  submit_dsm_screening: function (data) {
    let url = `${niyama}dsm-question-store/`;
    return service.post(url, data);
  },
  get_dsm_questions: function (type) {
    let url = `${niyama}get-dsm-question-list?type=${type}`;
    return service.get(url);
  },

  get_dsm_summary_list: function (data) {
    let url = `${niyama}dsm-answer-list/`;
    return service.post(url, data);
  },

  // Protective Factor
  submit_protective_factor: function (data) {
    let url = `${niyama}pf-question-save/`;
    return service.post(url, data);
  },
  get_protective_factor_questions: function () {
    let url = `${niyama}pf-question-list/`;
    return service.get(url);
  },

  get_protective_factor_summary_list: function (data) {
    let url = `${niyama}pf-answer-list/`;
    return service.post(url, data);
  },
  get_custom_doc_summary_list: function (data) {
    let url = `${niyama}multiple-file-ans-list/`;
    return service.post(url, data);
  },

  //PFR
  get_pfr_questions: function () {
    let url = `${niyama}psychiatryfb-question-list/`;
    return service.get(url);
  },
  submit_pfr: function (data) {
    let url = `${niyama}psychiatryfb-question-save/`;
    return service.post(url, data);
  },
  get_pfr_summary_list: function (data) {
    let url = `${niyama}psychiatryfb-answer-list/`;
    return service.post(url, data);
  },

  preview_psychiatry: function (data) {
    let url = `${niyama}preview-psychiatry-fb/`;
    return service.post(url, data);
  },

  publish_psychiatry: function (data) {
    let url = `${niyama}publish-psychiatry-fb/`;
    return service.post(url, data);
  },

  // DOT
  submit_dot: function (data) {
    let url = `${niyama}dot-question-save/`;
    return service.post(url, data);
  },
  get_dot_questions: function () {
    let url = `${niyama}dot-question-list/`;
    return service.get(url);
  },

  get_dot_summary_list: function (data) {
    let url = `${niyama}dot-answer-list/`;
    return service.post(url, data);
  },

  // SOS
  submit_sos: function (data) {
    let url = `${niyama}sos-question-save/`;
    return service.post(url, data);
  },
  get_sos_questions: function () {
    let url = `${niyama}sos-question-list/`;
    return service.get(url);
  },

  get_sos_summary_list: function (data) {
    let url = `${niyama}sos-answer-list/`;
    return service.post(url, data);
  },
  //CONFAS
  submit_confas: function (data) {
    let url = `${niyama}confas-question-save/`;
    return service.post(url, data);
  },
  get_confas_questions: function () {
    let url = `${niyama}confas-question-list/`;
    return service.get(url);
  },
  get_confas_summary_list: function (data) {
    let url = `${niyama}confas-answer-list/`;
    return service.post(url, data);
  },
  //CONPSYG
  submit_conpsyg: function (data) {
    let url = `${niyama}conpsyg-question-save/`;
    return service.post(url, data);
  },
  get_conpsyg_questions: function () {
    let url = `${niyama}conpsyg-question-list/`;
    return service.get(url);
  },
  get_conpsyg_summary_list: function (data) {
    let url = `${niyama}conpsyg-answer-list/`;
    return service.post(url, data);
  },
  //CONCOG
  submit_concog: function (data) {
    let url = `${niyama}concog-question-save/`;
    return service.post(url, data);
  },
  get_concog_questions: function () {
    let url = `${niyama}concog-question-list/`;
    return service.get(url);
  },
  get_concog_summary_list: function (data) {
    let url = `${niyama}concog-answer-list/`;
    return service.post(url, data);
  },
  //Stress/Emotion

  get_stress_emotion_list: function (data) {
    let url = `${niyama}list-stress-emotion/`;
    return service.post(url, data);
  },

  get_stress_emotion_update: function (data) {
    let url = `${niyama}emotion-stress-update/`;
    return service.post(url, data);
  },

  // therapy

  get_therapy_questions: function (type) {
    let url = `${niyama}get-theraphy-question-list/?type=${type}`;
    return service.get(url);
  },
  submit_therapy_questions: function (data) {
    let url = `${niyama}theraphy-question-store/`;
    return service.post(url, data);
  },
  get_therapy_summary_list: function (data) {
    let url = `${niyama}theraphy-answer-list/`;
    return service.post(url, data);
  },
  submit_composition_response_update: function (data) {
    let url = `${niyama}composition-response-update/`;
    return service.post(url, data);
  },
  //theraphy progress
  get_therapy_progress_note: function (appointment_id) {
    let url = `${niyama}get-therapy-progress-note/?appointment_id=${appointment_id}`;
    return service.get(url);
  },
  get_therapy_chart_summary: function (appointment_id) {
    let url = `${niyama}get-bpi-chart-summary/?appointment_id=${appointment_id}`;
    return service.get(url);
  },
  submit_therapy: function (data) {
    let url = `${niyama}therapy-progress-save/`;
    return service.post(url, data);
  },
  //mhe

  get_mhe_questions: function (type) {
    let url = `${niyama}get-mhe-question-list/`;
    return service.get(url);
  },
  mhe_post_answers: function (data) {
    let url = `${niyama}mhe-question-store/`;
    return service.post(url, data);
  },
  get_diagnosis_questions: function (type, app_id) {
    let url = `${niyama}get-case-formulation1-question-list/?type=${type}&appointment_id=${app_id}`;
    return service.get(url);
  },
  diagnosis_post_answers: function (data) {
    let url = `${niyama}case-formulation1-question-store/`;
    return service.post(url, data);
  },
  get_diagnosis_answer_list: function (data) {
    let url = `${niyama}case-formulation1-answer-list/`;
    return service.post(url, data);
  },
  get_diagnosis_data_answer_list: function (data) {
    let url = `${niyama}diagnosis-data-answer-list/`;
    return service.post(url, data);
  },
  get_caseformulation1_questions: function (type, app_id) {
    let url = `${niyama}get-case-formulation1-question-list/?type=${type}&appointment_id=${app_id}`;
    return service.get(url);
  },
  get_treatment_questions: function (type) {
    let url = `${niyama}get-case-formulation2-question-list/?type=${type}`;
    return service.get(url);
  },
  treatment_post_answers: function (data) {
    let url = `${niyama}case-formulation2-question-store/`;
    return service.post(url, data);
  },
  get_treatment_answer_list: function (data) {
    let url = `${niyama}case-formulation2-answer-list/`;
    return service.post(url, data);
  },
  get_dots_answer_list: function (data) {
    let url = `${niyama}dot-answer-list/`;
    return service.post(url, data);
  },
  get_sos_answer_list: function (data) {
    let url = `${niyama}sos-answer-list/`;
    return service.post(url, data);
  },
  short_hand_post: function (data) {
    let url = `${niyama}ahi-phi-save/`;
    return service.post(url, data);
  },

  get_mhe_answer_list: function (data) {
    let url = `${niyama}mhe-answer-list/`;
    return service.post(url, data);
  },

  get_therpay_prog_answer_list: function (data) {
    let url = `${niyama}therapy-progress-answer-list/`;
    return service.post(url, data);
  },

  // Consultation Status

  get_consultation_status: function (data) {
    let url = `${niyama}consultation-status/`;
    return service.post(url, data);
  },

  // client feedback rating

  feedback_rating: function(data){
    let url = `${niyama}client-feedback-save/`;
    return service.post(url, data);
  },

  // chat apis

  get_chat_list: function () {
    let url = `${niyama}list-chat/`;
    return service.get(url);
  },

  assign_chat: function (data) {
    let url = `${niyama}assign-care-admin/`;
    return service.post(url, data);
  },
  // close_chat: function (data) {
  //   let url = `${niyama}close-chat/`
  //   return service.post(url, data);
  // },

  // care admin chat apis

  get_care_admin_domain_list: function () {
    let url = `${niyama}care-admin-domain-list/`;
    return service.get(url);
  },
  care_admin_domain_update: function (data) {
    let url = `${niyama}care-admin-domain-update/`;
    return service.post(url, data);
  },

  fcm_token_update: function (token) {
    let data = {
      type: "web",
      fcm_token: token,
    };
    let url = `${firebase}fcm-token-update/`;
    return service.post(url, data);
  },

  update_care_admin_status: function (data) {
    let url = `${niyama}update-care-admin-status/`;
    return service.post(url, data);
  },
  get_patient_chat_details: function () {
    let url = `${niyama}patient-chat-token-details/`;
    return service.post(url);
  },

  close_chat: function (data) {
    let url = `${niyama}close-chat/`;
    return service.post(url, data);
  },

  get_care_admin_chat: function () {
    let url = `${niyama}get-current-chat-status/`;
    return service.get(url);
  },

  get_patient_chat_status: function () {
    let url = `${niyama}get-patient-chat-status/`;
    return service.get(url);
  },

  get_care_admin_chat_status: function () {
    let url = `${niyama}get-care-chat-status/`;
    return service.get(url);
  },

  get_chat_updated_token: function (data) {
    let url = `${niyama}get-chat-updated-token/`;
    return service.post(url, data);
  },

  update_conversation_attributes: function (data) {
    let url = `${niyama}update-conversation-attributes/`;
    return service.post(url, data);
  },

  confirm_participant: function (data) {
    let url = `${firebase}confirm-participant/`;
    return service.post(url, data);
  },

  patient_chat_token_details: function () {
    let url = `${niyama}patient-chat-token-details/`;
    return service.post(url);
  },

  // prescription-pdf

  get_prescription_pdf: function (appointment_id) {
    let url = `${niyama}generate-pdf-content/`;
    return service.post(url, {
      appointment_id: appointment_id,
      type: "ayurveda",
    });
  },

  get_prescription_pdf_allopathy: function (data) {
    let url = `${niyama}generate-pdf-content/`;
    return service.post(url, data);
  },
  //coupon -payment
  coupon_apply: function (coupon_code, service_id) {
    let url = `${niyama}get-subscription-amount/`;
    return service.post(url, { coupon_code, service_id });
  },
  // video-consultation-therapy-list

  get_consultation_therapy_list: function (data) {
    let url = `${niyama}list-theraphy/`;
    return service.post(url, data);
  },
  get_analytics_data: function () {
    let url = `${niyama}get-quicksight-url/`;
    return service.get(url);
  },
  get_analytics_dashboard_data: function (data) {
    let url = `${niyama}get-quick-sight-data/`;
    // url ="https://beta.stg.niyama.ai/api/niyama-api/v1.10.0/get-quick-sight-data/";
    return service.post(url, data);
  },
  get_quick_sight_uid: function (role = "") {
    let url = `${niyama}get-quick-sight-uid/?role=${role}`;
    // url = "https://beta.stg.niyama.ai/api/niyama-api/v1.10.0/get-quick-sight-uid/";
    return service.get(url);
  },

  //dashboard-api
  get_health_information: function (data) {
    let url = `${niyama}health-information/?page=${data}`
    return service.get(url);
  },

  get_care_plan_dashboard: function (data){
    let url =`${niyama}care-plans/?page=${data}`
    return service.get(url);
  },

  get_assessment_details: function (){
    let url = `${niyama}assessment-by-type/`
    return service.get(url);
  },

  //Super admin
  get_doctor_specification: function () {
    let url = `${niyama}doctor-specialty-list/`;
    return service.get(url);
  },
  get_careadmin_domain: function () {
    let url = `${niyama}care-admin-domain-list/`;
    return service.get(url);
  },
  create_individual_role: function (data) {
    let url = `${niyama}individual-account-creation/`;
    return service.post(url, data);
  },
  create_bulk_patient: function (data) {
    let url = `${niyama}bulk-account-creation-dup/`;
    return service.post(url, data);
  },
  upload_bulk_patient_doc: function (data) {
    let url = `${niyama}user-document-handling/`;
    return service.post(url, data);
  },
  add_Service: function (data) {
    let url = `${niyama}add - service/`;
    return service.post(url, data);
  },
  post_admin_csv: function (formdata) {
    let url = `${niyama}user-document-handling/`;
    return service.post(url, formdata);
  },

  get_ticketlist_nofilter: function (page) {
    let url = `${niyama}list-all-tickets/?ticket_type=All&page=1&page_size=10`;
    return service.get(url);
  },
  get_ticketlist_filter: function ({ pageNo, pageSize }) {
    let url = `${niyama}list-all-tickets/?ticket_type=All&page=${pageNo}&page_size=${pageSize}`;
    return service.get(url);
  },
  get_ticketlist_filterbytype: function ({ pageNo, pageSize, ticket_type }) {
    let url = `${niyama}list-all-tickets/?ticket_type=${ticket_type}&page=${pageNo}&page_size=${pageSize}`;
    return service.get(url);
  },
  get_ticketlist_filterurl: function (addurl) {
    let url = `${niyama}list-all-tickets/?${addurl}`;
    return service.get(url);
  },
  get_consultationlist: function (data) {
    let url = `${niyama}consultation-current-status/?page=1&page_size=${10}&type=${data.selectedTab}`;
    return service.get(url);
  },
  get_consultationlist_pagination: function ({ pageNo, pageSize, selectedTab }) {
    let url = `${niyama}consultation-current-status/?page=${pageNo}&page_size=${pageSize}&type=${selectedTab}`;
    return service.get(url);
  },
  get_consultationlist_filterbypatient: function ({
    pageNo,
    pageSize,
    patient_name,
  }) {
    let url = `${niyama}consultation-current-status/?page=${pageNo}&page_size=${pageSize}&type=patient_name&filter=${patient_name}`;
    return service.get(url);
  },
  get_consultationlist_filterurl: function (addurl) {
    let url = `${niyama}consultation-current-status/?${addurl}`;
    return service.get(url);
  },
  //care admin rating comment submit
  care_admin_rating_comment: function(data){
    let url = `${niyama}admin-comment-for-rating/`;
    return service.post(url, data);
  },
  // video conference

  get_video_conference: function (appointment_id) {
    let url = `${niyama}video-conferance-api/`;
    return service.post(url, { app_id: appointment_id });
  },

  // FAQ

  get_faq_details: function (data) {
    let url = `${niyama}chat-details/`;
    return service.post(url, data);
  },
  // chat bot apis

  check_chat_bot_status: function () {
    // let url = `${niyama}start-chat-bot/`;
    let url = `/chat-bot/v1.9.0/check-chat-status/`;
    return service.post(url);
  },

  start_chat_bot: function (data) {
    let url = `/chat-bot/v1.9.0/start-chat/`;
    return service.post(url, data);
  },

  send_chat_bot_message: function (data) {
    let url = `/chat-bot/v1.9.0/post-chat-message/`;
    return service.post(url, data);
  },
  
  post_chat_message: function (data) {
    let url = `/chat-bot/v2.0.0/post-chat-message/`;
    return service.post(url, data);
  },

  get_chat_bot_message: function (data) {
    const {page=1,page_size=6}=data;
    let url = `/chat-bot/v2.0.0/post-chatbot-message/?page=${page}&page_size=${page_size}`;
    return service.post(url, data);
  },

  send_chat_bot_feedback: function (data) {
    let url = `/chat-bot/v1.9.0/post-feedback/`;
    return service.post(url, data);
  },

  close_chat_bot: function (data) {
    let url = `/chat-bot/v1.9.0/close-chat/`;
    return service.post(url, data);
  },

  // AI Support

  get_AI_Results: function (data) {
    let url = `${chatBot}post-query/`;
    return service.post(url, data);
  },
  //Video Preview
  get_video_link: function (data) {
    let url = `${niyama}video-streaming/`;
    return service.post(url, data);
  },
  // joinNow Appointment

  get_joinNow_appointment_details: function (data) {
    let url = `${niyama}appointment-details/`;
    return service.post(url, data);
  },

  // twilio connnectivity update

  submit_preflight_error: function (data) {
    let url = `${niyama}preflight-status-update/`;
    return service.post(url, data);
  },

  // Funneling APIs
  get_language_details: function (type) {
    let url = `${niyama}preferred-languages/`;
    return service.get(url);
  },
  get_language_details_new: function (type="en") {
    let url = `${niyama}preferred-languages/?language_type=${type}`;
    return service.get(url);
  },
  post_language: function ( data) {
    let url = `${niyama}set-preferred-language/`;
    return service.post(url, data);
  },
  get_age_group: function (uuid) {
    let url = `${niyama}age-categories/?uuid=${uuid}`;
    return service.get(url);
  },
  get_assessment_options: function (uuid) {
    let url = `${niyama}symptom-checklist/?uuid=${uuid}`;
    return service.get(url);
  },
  post_age_group: function ( data) {
    let url = `${niyama}save-age-category/`;
    return service.post(url, data);
  },
  post_selected_option: function ( data) {
    let url = `${niyama}save-symptom-checklist/`;
    return service.post(url, data);
  },
  post_quiz: function ( data) {
    let url = `${niyama}assessment-question-submit/`;
    return service.post(url, data);
  },
  select_profile: function ( data) {
    let url = `${niyama}submit-assessment/`;
    return service.post(url, data);
  },
  
  // Assessment answers list
  get_assesment_answers_list: function (type = "", data) {
    let url = `${niyama}assessment-answer/?type=${type}`;
    return service.post(url, data);
  },
  get_prescription: function (type) {
    let url = `${niyama}prescription-summary/?type=${type}`;
    return service.get(url);
  },
  submit_prescription: function (data) {
    let url = `${niyama}add-prescription/`;
    return service.post(url, data);
  },
  prescription_submit: function (data) {
    let url = `${niyama}add-prescription/`;
    return service.post(url, { ...data });
  },

  get_consultation_details: function (data) {
    let url = `${niyama}get-consultation-details/`;
    return service.post(url, data);
  },

  publish_prescription: function (data) {
    let url = `${niyama}publish-prescription/`;
    return service.post(url, data);
  },
  publish_evaluation: function (data) {
    let url = `${niyama}publish-evaluation/`;
    return service.post(url, data);
  },
  // All Prescriptions summary

  get_all_prescriptions: function (data) {
    let url = `${niyama}all-prescription-summary-list/`;
    return service.post(url, data);
  },

  // Speciality List

  get_speciality_list: function (data) {
    let url = `${niyama}get-specialty-list/`;
    return service.post(url, data);
  },

  // Speciality Doctors
  get_speciality_doctors_list: function (data) {
    let url = `${niyama}get-specialty-doctors-list/`;
    return service.post(url, data);
  },
  // create-referral-assignment-ticket

  create_referral: function (data) {
    let url = `${niyama}create-referral-assignment-ticket/`;
    return service.post(url, data);
  },
  // view-files

  view_files: function (data) {
    let url = `${niyama}view-files/`;
    return service.post(url, data);
  },

  save_new_diagnosis: function (data) {
    let url = `${niyama}diagnosis-data-question-store/`;
    return service.post(url, data);
  },
  get_new_diagnosis_answer_list: function (data) {
    let url = `${niyama}diagnosis-data-answer-list/`;
    return service.post(url, data);
  },
  post_med_id: function (data) {
    let url = `${niyama}medicine-search-result/`;
    return service.post(url, data);
  },
  get_med_params: function (params, val) {
    let url = `${niyama}get-medicine-by-params/?field=${params}&search=${val}`;
    return service.get(url, params);
  },
  get_default_options: function (params) {
    let url = `${niyama}get-medicine-by-params/?field=${params}`;
    return service.get(url, params);
  },
  post_add_medicine: function (data) {
    let url = `${niyama}add-new-medicine/`;
    return service.post(url, data);
  },
  medicine_list: function (pageNo, pageSize) {
    let url = `${niyama}medicine-list/?page=${pageNo}&page_size=${pageSize}`;
    return service.get(url);
  },
  medicine_delete: function (data) {
    let url = `${niyama}delete-medicine/`;
    return service.post(url, data);
  },
  
  preview_prescription: function (data) {
    let url = `${niyama}preview-prescription/`;
    return service.post(url, data);
  },
  preview_evaluation: function (data) {
    let url = `${niyama}preview-evaluation/`;
    return service.post(url, data);
  },
  preview_medical_test:  function(data){
    let url = `${niyama}preview-medical-prescription/`;
    return service.post(url,data);
  },

  get_default_icd_list: function () {
    let url = `${niyama}icd-list`;
    return service.get(url);
  },
  get_icd_suggestion: function (data) {
    let url = `${niyama}icd-list/?search=${data}`;
    return service.get(url, data);
  },
  get_icd_list: function (data) {

    let url = `${niyama}icd-list`;

    if(data) url = `${niyama}icd-list/?search=${data}`;

    return service.get(url, data);

  },
  get_new_consultation_details: function (data) {
    let url = `${niyama}get-consultation-details/`;
    return service.post(url, data);
  },
  get_new_diagnosis: function (data, app_id) {
    let url = `${niyama}diagnosis-data-question-list/?type=${data}&app_id=${app_id}`;
    return service.get(url, data);
  },
  get_med_suggestion: function (data, type, is_herbal) {
    let url = `${niyama}medicine-search-suggestion/?search=${data}&type=${type}&is_herbal=${is_herbal}`;
    return service.get(url, data);
  },
  get_zero_encoutner_list:function (patient_uid) {
    let url = `${niyama}zero-encounter-list/?patient_uid=${patient_uid}`;
    return service.get(url, patient_uid);
  },
  submit_zero_encounter_request:function (patient_uid) {
    let url = `${niyama}zero-encounter-save/`;
    return service.post(url, patient_uid);
  },
  get_time_zones_list : function() {
    let url = `${niyama}get-all-timezones/`;
    return service.get(url);
  },
  time_zone_update: function (timezone) {
    let url = `${niyama}time-zone-update/`;
    return service.post(url, timezone);
  },
  aisupport_chat_initiate:function (data) {
    let url = `${chatBot}start-chat/`;
    return service.post(url, data);
  },
  aisupport_chat_end:function (data) {
    let url = `${chatBot}update-feedback/`;
    return service.post(url, data);
  },
  // medical-test 

  get_test_suggestion:function(data){
    let url = `${niyama}medical-document-search-suggestion/?search=${data}`;
    return service.get(url);
  },
  get_uploaded_by:function(data){
    let url = `${niyama}option-detail/?type=${data}`;
    return service.get(url);
  },
  add_medical_test: function (data) {
    let url = `${niyama}add-medical-test/`;
    return service.post(url,data);
  },
   pubish_medical_test:function(data){
    let url = `${niyama}publish-medical-prescription/`;
    return service.post(url,data);
   },
   publish_prescription_list:function(data){
    let url = `${niyama}all-prescription-list/`;
    return service.post(url,data);
   },
   get_list_service:function(){
    let url =`${niyama}list-create-service/`
    return service.get(url)
   },
   coupon_create:function(data){
      let url = `${niyama}add-new-coupon/`
      return service.post(url,data)
   },
   /*** Plan Process mode***/
   plan_process_save:function(data){
    let url = `${niyama}plan-process-save/`
    return service.post(url,data)
 },

 get_care_intro_detail : function(){
  let url = `${niyama}profile-introduction/`
  return service.get(url)
 },

 get_clinician_list:function(){
  let url =`${niyama}all-clinicians/`
  return service.get(url)
 },

 save_b2b_selected_doctor: function(data) {
  let url = `${niyama}save-b2b-doctor-list/`
  return service.post(url,data)
 },

 save_clinicians: function(data){
  let url = `${niyama}save-clinicians/`;
  return service.post(url,data)
 },
   save_campaign_data:function(data){
    let url = `${niyama}save-campaign-data/`
    return service.post(url,data)
 },
 create_firebase_doc:function(data){
  let url = `/phi/create-document`;
  return service.post(url,data);
 },
 delete_firebase_doc:function(data){
  let url = `/phi/delete-document`;
  return service.post(url,data);
 },
 get_reviewed_forms:function(data){
  let url = `${phi}get-reviewed-details/`;
  return service.post(url,data);
 },
 update_ai_form_view:function(data){
  let url = `${phi}update-reviewed-details/`;
  return service.post(url,data);
 },
 save_ai_form:function(data){
  let url = `${phi}save-reviewed-details/`;
  return service.post(url,data);
 },
 get_past_app_dashboard:function(){
  let url=`${niyama}my-appointments/?page=1&page_size=3&type=past&status=closed`;
 return service.get(url)
 },
 
 get_consent_content: function(){
  let url = `${niyama}parental-consent/`;
  return service.get(url)
 },
 get_user_notifications: function(queryParams){
  let url = `${niyama}user-notifications/?type=${queryParams.type}&page=${queryParams.pageNo}&page_size=${queryParams.pageSize}`;
  return service.get(url)
 },
  get_next_steps: function(queryParams){
  let url = `${niyama}next-steps/?type=${queryParams.type}&page=${queryParams.pageNo}&page_size=${queryParams.pageSize}`;
  return service.get(url)
 },

 save_read_notifications: function(payload){
  let url = `${niyama}read-notification/`;
  return service.post(url,payload)
 },
 clinician_plan_list: function(payload){
  let url = `${niyama}clinician-plan-list/`;
  return service.post(url,payload)
 },
 dynamic_linking: function(payload){
  let url = `${niyama}deep-linking/`;
  return service.post(url,payload)
 },
 assessment_plan_details: function(payload){
  let url = `${niyama}assessment-plan-details/`;
  return service.post(url,payload)
 },
 publish_assessment: function(payload){
  let url = `${niyama}generate-assessment-report/`;
  return service.post(url,payload)
 },
 coupon_list: function(payload){
  let url = `${niyama}coupon-list/`;
  return service.post(url,payload)
 },
 save_user_analytics: function(payload){
  let url = `${niyama}save-user-analytics/`;
  return service.post(url,payload)
 },
 google_signin: function(payload){
  let url = `${authManager}google-signin/`;
  return service.post(url,payload)
 },
 apple_signin: function(payload){
  let url = `${authManager}apple-signin/`;
  return service.post(url,payload)
 },
 fetch_prescription_details: function(payload){
  let url = `${niyama}fetch-prescription-details/`;
  return service.post(url,payload)
 },
 fetch_investigation_details: function(payload){
  let url = `${niyama}fetch-investigation-details/`;
  return service.post(url,payload)
 },
 fetch_medical_document_details: function (patientID) {
    let url = `${niyama}fetch-medical-document-details/?patient_id=${patientID}`;
    return service.get(url);
  },
 fetch_single_page_casesheet: function (payload) {
    let url = `${niyama}fetch-single-page-casesheet/`;
    return service.post(url,payload);
  },
 save_single_page_casesheet: function (payload) {
    let url = `${niyama}save-single-page-casesheet/`;
    return service.post(url,payload);
  },
  preview_general_case_sheet: function (payload) {
    let url = `${niyama}preview-general-casesheet/`;
    return service.post(url,payload);
  },
  publish_general_case_sheet: function (payload) {
    let url = `${niyama}publish-general-casesheet/`;
    return service.post(url,payload);
  },
   get_relationship_options: function () {
    let url = `${niyama}relationship-options/`;
    return service.get(url);
  },
};
